import {
  Dialog,
  Toast,
  Loading,
  List,
  Rate,
  Progress,
  Sticky,
  ActionSheet,
  Overlay,
  Icon,
  Image,
  Popup,
} from "vant";
const VantComponents = [
  Dialog,
  Toast,
  Loading,
  List,
  Rate,
  Progress,
  Sticky,
  ActionSheet,
  Overlay,
  Icon,
  Image,
  Popup,
];

export default VantComponents;
